import __var_0__ from '@stdlib/math/base/special/pow';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var pow = __var_0__;


// MAIN //

/**
* Converts a double's fraction bit sequence to a numeric value.
*
* @private
* @param {string} frac - literal bit representation of a double's fraction bit sequence
* @returns {number} fraction)
*/
function toDouble( frac ) {
	var sum = 0;
	var i;
	for ( i = 0; i < frac.length; i++ ) {
		if ( frac[ i ] === '1' ) {
			sum += pow( 2.0, -(i+1) );
		}
	}
	return sum;
}


// EXPORTS //
export default toDouble;
